export const VIEWS = {
	GRID: 'grid',
	LIST: 'list'
};
export const PAGE_SIZE_KEY = 'myImagesPageSize';
export const PAGE_SIZES = [10, 20, 50];
export const DEFAULT_PAGE_SIZE = 10;
